export default __webpack_public_path__ + "static/media/3.1b32844d.png";